// extracted by mini-css-extract-plugin
export var anchor = "styles-module__anchor___OaLM_";
export var primary = "styles-module__primary___Wk1If";
export var secondary = "styles-module__secondary___qHdxr";